/**
 * Saving a blob the application already holds in memory as a file.
 *
 * A CSV export has already been authenticated and fetched through `apiClient` by the time this
 * runs — this only hands the browser bytes it already has. The object URL is revoked straight
 * after the click is dispatched; the anchor is never inserted into the document, which is not
 * required for `click()` to fire a download in any browser this application supports.
 */
export function saveBlobAsFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)

  try {
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.click()
  } finally {
    URL.revokeObjectURL(url)
  }
}
